/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tags_DefenseInputs */

const en_control_tags_defense = /** @type {(inputs: Control_Tags_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defense`)
};

const zh_control_tags_defense = /** @type {(inputs: Control_Tags_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防御`)
};

/**
* | output |
* | --- |
* | "Defense" |
*
* @param {Control_Tags_DefenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tags_defense = /** @type {((inputs?: Control_Tags_DefenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tags_DefenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tags_defense(inputs)
	return zh_control_tags_defense(inputs)
});
export { control_tags_defense as "control.tags.defense" }